import getClassNames from './getClassNames';
import { TBoxAugments } from '../../types/TBoxAugments';

/**
 * Build up Component and Child component class names
 *
 * @param root
 * @param children
 */
const getComponentClassNames = (
  root: string | [string, TBoxAugments?],
  children?: (string | [string, TBoxAugments?])[],
): {
  root: string;
  [key: string]: string;
} => {
  const output = {
    root: '',
  };
  let parent: string;
  if (typeof root === 'string') {
    output.root = getClassNames({ name: root });
    parent = root;
  } else {
    const name = root[0];
    output.root = getClassNames({ name, ...root[1] });
    parent = name;
  }
  if (children?.length) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (typeof child === 'string') {
        output[child] = getClassNames({ name: child, parent });
      } else {
        const name = child[0];
        output[name] = getClassNames({ name, parent, ...child[1] });
      }
    }
  }
  return output;
};

export default getComponentClassNames;
